import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

/**
 * Live IST clock that updates every second.
 * Shows: HH:MM:SS · Mon, 12 Feb
 */
export function ISTClock({ compact = false }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  // Convert to IST regardless of server/browser timezone
  const ist = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
  const hh = String(ist.getHours()).padStart(2, '0');
  const mm = String(ist.getMinutes()).padStart(2, '0');
  const ss = String(ist.getSeconds()).padStart(2, '0');
  const dateStr = ist.toLocaleDateString('en-IN', { weekday: 'short', day: '2-digit', month: 'short', timeZone: 'Asia/Kolkata' });

  if (compact) {
    return (
      <div className="flex items-center gap-1.5" data-testid="ist-clock-compact">
        <Clock className="h-3 w-3 text-[#16A34A]" />
        <span className="text-[11px] font-mono text-neutral-300 tabular-nums">{hh}:{mm}:{ss}</span>
        <span className="text-[10px] text-neutral-600 font-body">IST</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 px-3 py-2 bg-[#0F0F0F] border border-[#1A1A1A] rounded-lg" data-testid="ist-clock">
      <Clock className="h-3.5 w-3.5 text-[#16A34A] flex-shrink-0" />
      <div className="flex flex-col leading-tight">
        <span className="text-[12px] font-mono text-white tabular-nums tracking-tight">
          {hh}:{mm}<span className="text-[#16A34A]">:{ss}</span>
        </span>
        <span className="text-[9px] text-neutral-500 font-body uppercase tracking-wider">{dateStr} · IST</span>
      </div>
    </div>
  );
}

export default ISTClock;
